import { KeyboardEvent } from 'react';

export function onEnterTriggerClick(
  callback: (event: KeyboardEvent<HTMLElement>) => unknown
): (event: KeyboardEvent<HTMLElement>) => void;
export function onEnterTriggerClick(event: KeyboardEvent<HTMLElement>): void;
export function onEnterTriggerClick(
  eventOrCallback:
    | KeyboardEvent<HTMLElement>
    | ((event: KeyboardEvent<HTMLElement>) => unknown)
) {
  if (typeof eventOrCallback === 'function') {
    return (e: KeyboardEvent<HTMLElement>) => {
      if (e.key === 'Enter' && e.target !== null) {
        eventOrCallback(e);
      }
    };
  } else {
    if (eventOrCallback.key === 'Enter' && eventOrCallback.target !== null) {
      if (eventOrCallback.target instanceof HTMLInputElement) {
        eventOrCallback.target.click();
      } else {
        eventOrCallback.target.dispatchEvent(
          new Event('click', { bubbles: true })
        );
      }
    }
  }
}

export default onEnterTriggerClick;
